var map = {
	"./01.svg": "c12a",
	"./02.svg": "4183",
	"./03.svg": "41b4",
	"./04.svg": "8833",
	"./05.svg": "16b2",
	"./07.svg": "8cb6",
	"./08.svg": "472c",
	"./08purple.svg": "13b8",
	"./1.svg": "8269",
	"./add-button.svg": "5cd0",
	"./add-post.svg": "900b",
	"./affiliate-news.svg": "ce88",
	"./affiliate-offers.svg": "c2f0",
	"./affiliate-statistic.svg": "8aee",
	"./affiliate-streams.svg": "5a08",
	"./arrow-primary-left.svg": "ac0a",
	"./arrow-top.svg": "18d3",
	"./avatar-message.svg": "e2fb2",
	"./back-arrow.svg": "a3d8",
	"./back-page.svg": "614f",
	"./back-to-login.svg": "dc1e",
	"./black-supster.svg": "6ca7",
	"./bluetooth.svg": "6929",
	"./bluthoot-black.svg": "456d",
	"./bottom-arrow.svg": "7d0b",
	"./bp-analytics.svg": "1b3d",
	"./bp-auto-funnels.svg": "671c",
	"./bp-buttons.svg": "ff67",
	"./bp-content.svg": "3c6a",
	"./bp-customers.svg": "eb2a",
	"./bp-dropdown.svg": "572b",
	"./bp-goods-and-services.svg": "de61",
	"./bp-home.svg": "a455",
	"./bp-orders.svg": "99a8",
	"./bp-referral.svg": "d436",
	"./bp-sales-channels.svg": "4a41",
	"./bp-special-offers.svg": "476c",
	"./builder-avatar-stub.svg": "78f1",
	"./builder-post-locked.svg": "0543",
	"./builder-post-stub.svg": "9c64",
	"./bussines-menu-order.svg": "219c",
	"./charge-black.svg": "8d8a",
	"./charge.svg": "668d",
	"./chat-avatar.svg": "909c",
	"./chat-back.svg": "1d809",
	"./chat-blue.svg": "1224",
	"./chat-button.svg": "9f5a",
	"./chat-green.svg": "f0ef",
	"./chat-header-avatar.svg": "9e89",
	"./chat-menu-line.svg": "6986",
	"./chat.svg": "cc4e",
	"./chatgpt-icon-grad.svg": "fda5",
	"./chatgpt-icon.svg": "e3a2",
	"./chats-menu.svg": "e148",
	"./check.svg": "ab5c",
	"./checked-sources.svg": "0d4f",
	"./circle.svg": "adb1",
	"./close-icon.svg": "4bd1",
	"./close.svg": "3def",
	"./comments.svg": "0fbc",
	"./content-icon.svg": "b303",
	"./danger.svg": "bacf",
	"./dark-logo.svg": "7e73",
	"./dark-minus.svg": "43621",
	"./date-picker.svg": "9832",
	"./delete-chats-icon.svg": "f894",
	"./delete-chats.svg": "85c1",
	"./delete-filter.svg": "5abb",
	"./delete-sorting-icon.svg": "628b",
	"./delete-subs.svg": "b283",
	"./deleteChat.svg": "481b",
	"./device-comment.svg": "a7b2",
	"./device-like.svg": "537a",
	"./dropdown-arrow-main.svg": "539b",
	"./dropdown-arrow.svg": "f0d1",
	"./edit.svg": "772c",
	"./ellipse-check.svg": "5e52",
	"./ellipse.svg": "0a34",
	"./eye-crm2.svg": "a0db",
	"./eye.svg": "7659",
	"./facebook.svg": "3995",
	"./feed-button.svg": "9121",
	"./feed.svg": "bfd0",
	"./file-icon.svg": "e686",
	"./finances-block-icon-four.svg": "e07e",
	"./finances-block-icon-one.svg": "5519",
	"./finances-block-icon-three.svg": "4e25",
	"./finances-block-icon-two.svg": "4d78",
	"./finances-icon.svg": "72aa",
	"./fourg-black.svg": "1d7f",
	"./go-down.svg": "9dcc",
	"./gpt-badge.svg": "0d78",
	"./green-back-arrow.svg": "e90b",
	"./green-horiz.svg": "687c",
	"./home-icon.svg": "f9b0",
	"./homes.svg": "9f1b",
	"./icon-arrow-right-green.svg": "e032",
	"./icon-bottle.svg": "3013",
	"./icon-doublearow-left-green.svg": "c894",
	"./icon-options-1.svg": "102b",
	"./icon-options-2.svg": "5199",
	"./inform-arrow.svg": "954d",
	"./inform-verification.svg": "fd0c",
	"./instagram.svg": "63ca",
	"./lang-icon.svg": "a801",
	"./likes.svg": "70fe",
	"./line-icon.svg": "eb5c",
	"./liner-black.svg": "5ed5",
	"./lock-green.svg": "02d7",
	"./logo.svg": "3a96",
	"./logout-icon.svg": "8958",
	"./menu-bevel-circle.svg": "8f0f",
	"./menu-bevel.svg": "3be4",
	"./menu-down.svg": "e3af",
	"./message-avatar-four.svg": "c6f9",
	"./message-avatar-one.svg": "f23f",
	"./message-avatar-tree.svg": "e0cb",
	"./message-avatar-two.svg": "807d",
	"./message-border.svg": "2141",
	"./message-check.svg": "05ad",
	"./message-icon.svg": "736a",
	"./message.svg": "afc7",
	"./mini-delete.svg": "8da8",
	"./minus-dark.svg": "dad6",
	"./minus.svg": "7691",
	"./modal-settings.svg": "c1ce",
	"./more.svg": "f04e",
	"./more_down.svg": "e565",
	"./net.svg": "3c74",
	"./network.svg": "f0fb",
	"./new-channel-menu.svg": "4422",
	"./new-chats-menu.svg": "9c04",
	"./offersQuestion.svg": "f87f",
	"./options.svg": "ff44",
	"./order-number.svg": "53f3",
	"./orders-pagination-back.svg": "b839",
	"./orders-pagination-next.svg": "b0df",
	"./p.svg": "171d",
	"./page-avatar-two.svg": "65c1",
	"./page-icon-one.svg": "d0c6",
	"./pages.svg": "387f6",
	"./pass-icon-open.svg": "a89b",
	"./pass-icon.svg": "e76e",
	"./photo-device-icon-black.svg": "9f70",
	"./photo-device-icon.svg": "5721",
	"./photo-icon.svg": "746d",
	"./photo-lock.svg": "033f",
	"./photoFive.svg": "16f0",
	"./photoFour.svg": "24c5",
	"./photoOne.svg": "d433",
	"./photoThree.svg": "c51e",
	"./photoTwo.svg": "e593",
	"./pinnded-icon.svg": "02a0",
	"./plus-icon.svg": "8f7e",
	"./plus.svg": "fb0a",
	"./poll-icon.svg": "3461",
	"./post-icon-black.svg": "707b",
	"./post-icon.svg": "3dc1",
	"./pr-cog.svg": "84b4",
	"./pr-key.svg": "01ce",
	"./pr-profile.svg": "5ccb",
	"./preview-avatar-verification.svg": "714a",
	"./preview-avatar.svg": "6a5a",
	"./private-chat-avatar.svg": "4b67",
	"./profile-button-silver.svg": "2a1f",
	"./profile-button.svg": "cdc8",
	"./profile-share.svg": "bc89",
	"./profile-silver.svg": "d841",
	"./profile-stub-avatar.svg": "b86d",
	"./profile.svg": "c1f4",
	"./purple-arrow.svg": "ec2b",
	"./question-icons.svg": "867f",
	"./question.svg": "334d",
	"./red-close.svg": "3ffd",
	"./red-colser.svg": "f885",
	"./register-icon.svg": "8515",
	"./removePhoto.svg": "1556",
	"./resend-icon.svg": "f604",
	"./right-arrow.svg": "c4ca",
	"./russia-flag-icon.svg": "3c20",
	"./russia-flag.svg": "0363",
	"./s.svg": "5c69",
	"./search-button.svg": "7565",
	"./search.svg": "c837",
	"./seen-icon.svg": "e60d",
	"./send.svg": "dc92",
	"./setpCheck.svg": "7de3",
	"./settingsEight.svg": "df92",
	"./settingsFive.svg": "ad1b",
	"./settingsFour.svg": "6b00",
	"./settingsNine.svg": "773e",
	"./settingsOne.svg": "020d",
	"./settingsSeven.svg": "6bbe",
	"./settingsSix.svg": "ccf0",
	"./settingsTree.svg": "007c",
	"./settingsTwo.svg": "32be",
	"./share-icon.svg": "44fa",
	"./shat-pin-icon-green.svg": "8646",
	"./shat-pin-icon.svg": "4974",
	"./shop-icon-black.svg": "0c5f",
	"./shop-icon.svg": "244b",
	"./show-page-icon.svg": "2897",
	"./showMenu.svg": "d748",
	"./side-bar-icon.svg": "2d2c",
	"./silver-profile.svg": "c33c",
	"./sort.svg": "e582",
	"./sorting-icon.svg": "c6b3",
	"./sorting.svg": "60a3",
	"./star.svg": "44c1",
	"./statistic-payment.svg": "b3c8",
	"./statistic-sort-icon.svg": "cbf9",
	"./statistic-subscriptions-all.svg": "34ad",
	"./statistic-subscriptions-block.svg": "9759",
	"./statistic-unfollowl.svg": "3a65",
	"./step1.svg": "18e2",
	"./subs-sel.svg": "ba3b",
	"./subscription-icon-1.svg": "db5c",
	"./subscription-icon-2.svg": "d84b",
	"./subscription-icon-3.svg": "a0b2",
	"./subscription-icon-4.svg": "60445",
	"./sup.svg": "9430",
	"./supLogo.svg": "26cf",
	"./supster-preview-logo.svg": "c57a",
	"./supster.svg": "654c",
	"./table-question.svg": "760f",
	"./tabs.svg": "5b26",
	"./tariff-icon-1.svg": "bdf7",
	"./tariff-icon-2.svg": "b06a",
	"./tariff-icon-3.svg": "fbdc",
	"./telegram.svg": "91b2",
	"./triange.svg": "fa61",
	"./ulpoadPhoto.svg": "5e05",
	"./unchecked.svg": "0fc9",
	"./union.svg": "2e20",
	"./unlock-green.svg": "759c",
	"./user-shown-icon.svg": "e71f",
	"./vector.svg": "c275",
	"./vertical-dots.svg": "6717",
	"./video-device-icon.svg": "a3cd",
	"./video-icon.svg": "d230",
	"./vk.svg": "94ed",
	"./white-down.svg": "d574",
	"./youtube.svg": "bd5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba74";